import { FlexRow } from '@make-software/cspr-design';
import styled from 'styled-components';

export const Container = styled(FlexRow)`
  padding: 16px 0;
`;
